import { FIELD_DEFAULT_RESOLVER_REGISTRY } from '../utils/templateEngine';
import type { FieldDefaultResolver } from '../types/ticketTypeTemplate';

/** Primary Service Area — flat $45 callout (BCallOut.Standard / RCallOut.Standard).
 *  Anywhere outside this list defaults to Extended (time-billed travel). */
export const STANDARD_SERVICE_AREA_SUBURBS: string[] = [
  'Allawah',
  'Banksia',
  'Bardwell Park',
  'Bardwell Valley',
  'Bexley',
  'Bexley North',
  'Beverley Park',
  'Beverly Hills',
  'Blakehurst',
  'Brighton-Le-Sands',
  'Carlton',
  'Carss Park',
  'Connells Point',
  'Dolls Point',
  'Hurstville',
  'Hurstville Grove',
  'Kingsgrove',
  'Kogarah',
  'Kogarah Bay',
  'Kyle Bay',
  'Kyeemagh',
  'Lugarno',
  'Monterey',
  'Mortdale',
  'Narwee',
  'Oatley',
  'Peakhurst',
  'Peakhurst Heights',
  'Penshurst',
  'Ramsgate',
  'Ramsgate Beach',
  'Riverwood',
  'Rockdale',
  'Sandringham',
  'Sans Souci',
  'South Hurstville',
  'Turrella',
  'Wolli Creek',
  'Arncliffe',
  'Hurstville South',
  'Kingsgrove North',
  'Mortdale Heights',
  'Roselands',
  'Alfords Point',
  'Bangor',
  'Barden Ridge',
  'Bonnet Bay',
  'Bundeena',
  'Burraneer',
  'Caringbah',
  'Caringbah South',
  'Como',
  'Cronulla',
  'Dolans Bay',
  'Engadine',
  'Grays Point',
  'Greenhills Beach',
  'Gymea',
  'Gymea Bay',
  'Heathcote',
  'Illawong',
  'Jannali',
  'Kangaroo Point',
  'Kareela',
  'Kirrawee',
  'Kurnell',
  'Lilli Pilli',
  'Loftus',
  'Lucas Heights',
  'Maianbar',
  'Menai',
  'Miranda',
  'Oyster Bay',
  'Port Hacking',
  'Sandy Point',
  'Sutherland',
  'Sylvania',
  'Sylvania Waters',
  'Taren Point',
  'Waterfall',
  'Woolooware',
  'Woronora',
  'Woronora Heights',
  'Yarrawarrah',
  'Yowie Bay',
  'Audley',
  'Como West',
  'Royal National Park',
  'Sylvania Heights',
  'Woronora Dam',
  'Warumbul',
];

const STANDARD_SET = new Set(
  STANDARD_SERVICE_AREA_SUBURBS.map(s => s.toLowerCase()),
);

/** Normalise a Dataverse city value: lowercase, trim, strip a trailing
 *  state/postcode (e.g. "Cronulla NSW 2230" → "cronulla"). */
function normaliseCity(city: string): string {
  return city
    .toLowerCase()
    .trim()
    .replace(/\s+(nsw|act|vic|qld|sa|wa|tas|nt)\b.*$/i, '')
    .trim();
}

export function isStandardServiceArea(city: string | undefined): boolean {
  if (!city) return false;
  return STANDARD_SET.has(normaliseCity(city));
}

const standardOrExtendedFromCity: FieldDefaultResolver = ({ customer }) =>
  isStandardServiceArea(customer.city) ? 'standard' : 'extended';

FIELD_DEFAULT_RESOLVER_REGISTRY['standardOrExtendedFromCity'] = standardOrExtendedFromCity;
